<template>
    <div id="commdityLeft" class="pr">
        <div class="displayWrap" v-for="(item,index) in prop.slice(0,10)" :key="index" :style="height?{height:height+'px',overflow:'hidden'}:'auto'">
            <div class="title mb10" id="title">
                <el-divider>{{item.title}}</el-divider>
            </div>
            <div class="commdity" v-for="(itemSub,i) in item.commdity" :key="i">
                <router-link :to="'/goodDetail/'+itemSub.goods_id" target="_blank" class="clearfix tc">
                    <div class="imgBox">
                        <img :src="itemSub.original_img | thumbnailUrl" />
                    </div>
                    <div class="name mt5">{{ itemSub.common_name }}<span v-if="itemSub.goods_name!==''">({{ itemSub.goods_name }})</span></div>
                    <div class="price">{{ itemSub.goods_spec }}</div>
                </router-link>
            </div>
        </div>
        <div v-if="pageButton" class="pageButton">
            <i class="el-icon-arrow-down" @click="scrollDown"></i>
            <i class="el-icon-arrow-up" @click="scrollUp"></i>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    props: ['prop','pageButton','height','father'],
    methods: {
        gotoDetail(itemSub) {
            this.$router.push(`/goodDetail/${itemSub.goods_id}`);
        },
        scrollDown() {
            let height = $('.commdity').outerHeight()
            let initialScroll = $('.displayWrap').scrollTop()
            let titleHeight = $('#title').height()
            let commdityLength = this.prop[0].commdity.length
            console.log(commdityLength)
            $('.displayWrap .commdity').eq(-2).clone().append('.displayWrap')
            if(initialScroll==0 && initialScroll < commdityLength * height ) {
                $('.displayWrap').stop().animate({scrollTop: initialScroll + height + titleHeight  }, 300);
            }else if(0 < initialScroll+height < commdityLength * height){
                $('.displayWrap').stop().animate({scrollTop: initialScroll + height }, 300);
            }else{
                $('.displayWrap').scrollTop(0)
            }
            
        },
        scrollUp() {
            let height = $('.commdity').height()
            let initialScroll = $('.displayWrap').scrollTop()
            $('.displayWrap').stop().animate({scrollTop: initialScroll - height }, 300);
        }
    }
}
</script>

<style lang="scss" scoped>
    .displayWrap{
        width: 223px;
        font-size: 18px;
        .title{
            font-size: 15px;
            height: 45px;
            line-height: 45px;
            font-weight: 700;
            text-align: center;
            color: #444;
        }
    }
    
    .commdity{
        cursor: pointer;
        font-size: 14px;
        margin-bottom: 8px;
        & > div{
            text-align: center;
        }
        img{
            width: 140px;
            height: 140px;
            object-fit: contain;
        }
    }
    .pageButton{
        font-size: 25px;
        position: absolute;
        bottom: -50px;
        left: 50%;
        transform: translateX(-50%);
        .el-icon-arrow-down{
            margin-right: 15px;
            cursor: pointer;
        }
        .el-icon-arrow-up{
            cursor: pointer;
        }
    }
</style>